import { Text } from "@chakra-ui/react";
import WidgetBox from "components/elements/WidgetBox/widget-box";

const StatBox = ({
	title,
	stat,
	description,
}: {
	title: string;
	stat: any;
	description?: string;
}) => {
	return (
		<WidgetBox>
			<Text fontSize="30px" fontWeight="700" color="black">
				{stat}
			</Text>
			<Text fontSize="14px" fontWeight="600" color="black">
				{title}
			</Text>
			{description && <Text fontSize="12px">{description}</Text>}
		</WidgetBox>
	);
};

export default StatBox;
